import React, { useCallback } from 'react';
import {
  path as rPath
} from 'ramda'
import Button from '@mui/material/Button';
import { withStyles } from '@mui/styles';
import SingleTextInput from './SingleTextInput';
import * as cx from 'classnames';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
})

const MultipleTextInput = React.memo(function MultipleTextInput({
  classes,
  nodes,
  details,
  updateDetail,
  collectivePath
}) {
  return (
    <div className={classes.root}>
      {nodes.map((nodeConfig, index) => {
        const { path } = nodeConfig;
        const value = rPath(path.split('.'), details)
        const onChange = useCallback((newVal) => {
          const newCollectiveVal =  nodes.map(({path: componentPath}) => {
            if (path === componentPath) return newVal;
            return rPath(componentPath.split('.'),details) || ''
          }).join(' ')
          updateDetail(path, newVal);
          updateDetail(collectivePath, newCollectiveVal);
        }, [details, nodes, path, updateDetail, collectivePath]);
        return (
          <SingleTextInput key={index} {...nodeConfig} onChange={onChange} value={value} />
        );
      })}
    </div>
  )
})

export default withStyles(styles)(MultipleTextInput);